import { gantt } from '@blackhyve/dhtmlx-gantt';
import { differenceInDays } from 'date-fns';
import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import { parseDate } from '@blackhyve/utilities/dates';

export const formatTaskPayload = (data, projectId) => {
  const payload = {
    name: data.text,
    id: data.id,
    project_id: projectId ? projectId : data?.project_id,
    parent_id: data?.parent !== -1 ? data?.parent : null,
    imported_parent_id: data?.imported_parent_id,

    scheduled_start: format(data.start_date, 'yyyy-MM-dd'),
    forecasted_start: data.forecasted_start_date
      ? format(data.forecasted_start_date, 'yyyy-MM-dd')
      : null,
    scheduled_end: format(addDays(data.scheduled_end_date, -1), 'yyyy-MM-dd'),
    forecasted_end: format(addDays(data.end_date, -1), 'yyyy-MM-dd'),

    duration_days: data?.duration,
    duration_string: data?.duration_string,
    cal_days: data?.cal_days,

    percent_complete: data?.percent_complete,
    crew_size: data?.crew_size,
    optimal_crew: data?.optimal_crew,
    critical_path: data?.critical_path,

    effort_tag: data?.effort_tag,
    effort_hours: data?.effort_hours,

    free_float: data?.free_float,
    total_float: data?.total_float,

    area_id: data?.area_id,
    zone_id: data?.zone_id,
    location_id: data?.location_id,

    constraint_type: data?.constraint_type,
    constraint_date: data?.constraint_date ? format(data.constraint_date, 'yyyy-MM-dd') : '',

    target: data?.target,
    status: data?.status,
    users: data?.users,
    is_lookahead: data?.is_lookahead ? data.is_lookahead : false,

    is_scope: data?.is_scope ? data?.is_scope : false,
    color: data?.$color ? data?.$color : data.color,
    trades: data?.trades?.length ? data?.trades : [],
  };
  return payload;
};

export const formatTaskResponse = (task) => {
  const startDate = parseDate(task.scheduled_start);
  const endDate = addDays(parseDate(task.scheduled_end), 1);
  const taskObj = {
    id: task.id,
    text: task.name,
    parent: task.parent_id ? task.parent_id : -1,
    start_date: startDate,
    forecasted_start_date: task.forecasted_start ? parseDate(task.forecasted_start) : startDate,
    scheduled_end_date: endDate,
    end_date: addDays(parseDate(task.forecasted_end), 1),
    duration: task.duration_days ? task.duration_days : parseInt(task.duration_string),
    cal_days: task.cal_days ? task.cal_days : differenceInDays(endDate, startDate),
    progress: task.percent_complete,
    percent_complete: task.percent_complete,
    baseline_start: task.baseline_start,
    uuid: task.uuid,
    baseline_end: task.baseline_end ? parseDate(task.baseline_end) : undefined,
    baseline_duration: task.baseline_duration,
    crew_size: task.crew_size,
    optimal_crew: Boolean(task.optimal_crew),
    work_time: true,
    duration_string: task.duration_string ? task.duration_string : task.duration_days,
    effort_tag: task.effort_tag,
    location_id: task.location_id,
    zone_id: task.zone_id,
    area_id: task.area_id,
    effort_hours: task.effort_hours,
    shift: task.shift,
    workday_calendar: task.workday_calendar,
    pace: task.pace,
    pr: task.pr,
    latest_job_walk: task.latest_job_walk,
    project_id: task.project_id,
    status: task.status,
    critical_path: task.critical_path,
    children: task.children ? task.children : [],
    constraint_type: task.constraint_type ? task.constraint_type : 'ASAP',
    constraint_date: task.constraint_date ? parseDate(task.constraint_date) : '',
    free_float: task.free_float,
    total_float: task.total_float,
    type: task.is_parent ? 'parent_task' : gantt.config.types.task,

    is_lookahead: task?.is_lookahead,
    is_parent: task?.is_parent,
    is_scope: task?.is_scope,
    qty_type: task.qty_type,
    qty: task.qty,
    qty_per_day: task.production_rate,
    users: task.users ? task.users.map(({ user_id }) => user_id) : [],
    $color: task?.color,
    trades: task?.trades?.length ? task?.trades : [],
  };
  return taskObj;
};
